"use strict";

exports.__esModule = true;
exports.DropdownProvider = exports.DropdownContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useDropdownState2 = _interopRequireDefault(require("../../Dropdown/useDropdownState"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DropdownContext = (0, _react.createContext)({});
exports.DropdownContext = DropdownContext;

var DropdownProvider = function DropdownProvider(_ref) {
  var children = _ref.children,
      onToggle = _ref.onToggle;

  var _useDropdownState = (0, _useDropdownState2["default"])({
    open: false,
    onToggle: onToggle
  }),
      open = _useDropdownState.open,
      componentRef = _useDropdownState.componentRef,
      openDropdown = _useDropdownState.openDropdown,
      closeDropdown = _useDropdownState.closeDropdown,
      toggleDropdown = _useDropdownState.toggleDropdown;

  var data = {
    open: open,
    openUI: openDropdown,
    closeUI: closeDropdown,
    toggleUI: toggleDropdown,
    componentRef: componentRef
  };
  return /*#__PURE__*/_react["default"].createElement(DropdownContext.Provider, {
    value: data
  }, children);
};

exports.DropdownProvider = DropdownProvider;
DropdownProvider.propTypes = {
  /** what we want Dropdown to call when open/close state changes */
  onToggle: _propTypes["default"].func
};
DropdownProvider.defaultProps = {
  onToggle: null
};